import { DeckLeglaity, LegalityChecker } from '../deckLegality'

import CheckCommanderLeglaity from './commander.format'

const CheckDualCommanderLegality: LegalityChecker = (deck: DeckLeglaity) => {
  deck.checkBannedAsCommander()

  CheckCommanderLeglaity(deck)
}

export default CheckDualCommanderLegality
